// extracted by mini-css-extract-plugin
module.exports = {"nation":"Index_nation__6sQAT","emailAddress":"Index_emailAddress__skFes","entityName":"Index_entityName__Uv6qK","entityType":"Index_entityType__OPj0B"};